<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component
          :messages="errors"
          :error="errors.length > 0"
          :title="'general.problemOccurred'"
          :withEmplyFields="true"
          @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline is-paddingless">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeSignatureElectroniqueEncours.filtre.referenceCode')">
              <b-input v-model="critereRecherche.referenceCode"></b-input>
          </b-field>
        </div><div class="column is-12 pdb-0 mgt-10px">
          <libelle-tag-input
                      :label="$t('listeSignatureElectroniqueEncours.filtre.etat')"
                      :items="etatsFiltrables"
                      v-model="etatContratSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
            :label="$t('listeSignatureElectroniqueEncours.filtre.commercial')"
            v-model="commercialSelected"
            :blocked="userIsCommercialBlocked"
            :items="listeCommercial">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
            :label="$t('listeSignatureElectroniqueEncours.filtre.assistant')"
            v-model="assistantSelected"
            :items="listeAssistant">
          </user-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('general.button.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche from '@/services/signatureElectronique/genererCritereRechercheSignatureEncours';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL, ASSISTANT_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import { SET_CRITERE } from '@/store/modules/commun/signatureElectronique-mutation-type';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import { LISTE_ETAT_CONTRAT_SIGNATURE } from '@/configuration/signatureElectronique/signatureElectroniqueConf';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const SignatureElectronique = createNamespacedHelpers('signatureElectronique');

export default {
  components: {
    userTagInput,
    errorMsgComponent,
    libelleTagInput,
  },
  data() {
    return {
      errors: [],
      critereRecherche: null,
      listeCommercial: [],
      listeAssistant: [],
      commercialSelected: [],
      assistantSelected: [],
      etatContratSelected: [],
      constantes: {
        LISTE_ETAT_CONTRAT_SIGNATURE: LISTE_ETAT_CONTRAT_SIGNATURE,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...SignatureElectronique.mapGetters({
      criteresRecherche: 'criteresRecherche',
    }),
    blocageFiltreCommercial() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercialBlocked() {
      return (this.user.profil === COMMERCIAL && this.blocageFiltreCommercial);
    },
    etatsFiltrables() {
      return this.constantes.LISTE_ETAT_CONTRAT_SIGNATURE.filter(e => e.filtre);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...SignatureElectronique.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    async viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRecherche());
      this.commercialSelected = [];
      this.assistantSelected = [];
      this.etatContratSelected = [];
      await updateCritereWithParametreInterne(this.critereRecherche);
      await this.majFiltre();
    },
    appliquerCritere() {
      this.critereRecherche.contratEtatsSignature = this.etatContratSelected.map(el => {
        return el.code;
      });
      this.critereRecherche.commercialId = this.commercialSelected.map((c) => {
        return c.id;
      });
      this.critereRecherche.assistantId = this.assistantSelected.map((a) => {
        return a.id;
      });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async majFiltre() {
      const users = (await this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur));
      this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL], this.$i18n.t('listeDevis.filtre.noCommercial'));
      this.listeAssistant = initialUsers(users, [ASSISTANT_COMMERCIAL], this.$i18n.t('listeFactures.filtre.noAssistant'));

      this.commercialSelected = this.listeCommercial.filter((c) => {
        return this.critereRecherche.commercialId.includes(c.id);
      });

      this.assistantSelected = this.listeAssistant.filter((a) => {
        return this.critereRecherche.assistantId.includes(a.id);
      });
      if (this.critereRecherche.contratEtatsSignature) {
        this.etatContratSelected = this.constantes
          .LISTE_ETAT_CONTRAT_SIGNATURE.filter((c) => {
            return this.critereRecherche.contratEtatsSignature.includes(c.code);
          });
      }
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.criteresRecherche);
        await updateCritereWithParametreInterne(this.critereRecherche);
        await this.loadParametreUtilisateur();
        await this.majFiltre();
        await this.loadParametresInterne([
          typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key]);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    await this.initializeFiltre();
  },
};
</script>
